import { render, staticRenderFns } from "./studentsListAudit.vue?vue&type=template&id=67374c49&scoped=true"
import script from "./studentsListAudit.vue?vue&type=script&lang=js"
export * from "./studentsListAudit.vue?vue&type=script&lang=js"
import style0 from "./studentsListAudit.vue?vue&type=style&index=0&id=67374c49&prod&lang=less"
import style1 from "./studentsListAudit.vue?vue&type=style&index=1&id=67374c49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67374c49",
  null
  
)

export default component.exports